module.exports = __webpack_public_path__ + "static/media/profile-img.fd6b6b0e.png";